/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * HPAScalingPolicyType is the type of the policy which could be used while making scaling decisions. PODS_SCALING_POLICY - A policy used to specify a change in absolute number of pods. PERCENT_SCALING_POLICY - A policy used to specify a relative amount of change with respect to the current number of pods.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1HPAScalingPolicyType = {
    HPA_SCALING_POLICY_TYPE_UNSPECIFIED: 'HPA_SCALING_POLICY_TYPE_UNSPECIFIED',
    PODS_SCALING_POLICY: 'PODS_SCALING_POLICY',
    PERCENT_SCALING_POLICY: 'PERCENT_SCALING_POLICY'
} as const;

export type WorkloadoptimizationV1HPAScalingPolicyType = typeof WorkloadoptimizationV1HPAScalingPolicyType[keyof typeof WorkloadoptimizationV1HPAScalingPolicyType];



